import { ArrowUpRight } from "lucide-react";
import { waLink } from "@/lib/site";
import { Reveal } from "./Reveal";

export default function Coverage() {
  return (
    <section
      id="cobertura"
      data-testid="coverage-section"
      className="scroll-mt-24 py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.35em] text-violet-400">/ COBERTURA</p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-10 rounded-2xl border border-white/10 bg-surface p-8 sm:p-10">
            <h3 className="font-display text-2xl font-bold">
              Sua rua pode ser a próxima.
            </h3>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-white/60">
              Nossa rede cresce pela cidade a cada mês. Consulte a
              disponibilidade no seu endereço.
            </p>
            <p className="mt-4 text-xs text-white/40">
              * A disponibilidade pode variar por rua.
            </p>
            <a
              data-testid="coverage-cta"
              href={waLink(
                "Olá! Quero saber se a HPNET atende no meu endereço em Bertioga."
              )}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-7 inline-flex items-center gap-2 rounded-md bg-violet-600 px-8 py-4 text-sm font-medium text-white shadow-[0_0_30px_rgba(124,58,237,0.4)] transition-colors duration-200 hover:bg-violet-500"
            >
              Consultar meu endereço
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
